import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Form,
	FormGroup,
	Label,
	Input,
	Row,
	Col, InputGroup,
	InputGroupText,
} from 'reactstrap';
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';
import { Formik, Field } from 'formik';
import FormikInputField from 'components/common/Fields/FormikInputField';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faClose } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import Calendar from "assets/icon/calendar-icon.svg";
import moment from "moment";
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import NDCList from 'components/NDCList';
import Loader from 'components/Loader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactInputMask from 'react-input-mask';
import cancel from 'assets/icon/cancel.svg';
import save from "assets/icon/save.svg";

const initialValues = {
	ndc: '',
	accumulation: '',
	qtyordered: '',
	qtyreceived: '',
	qtybilled: '',
	packagesprice: '',
	totalprice: '',
	comment: ''
};
let hasDatePopupOpen = false;
const validationSchema = Yup.object().shape({
	ndc: Yup.string().required('Ndc is required field'),
	//accumulation: Yup.string().required('Required'),
	qtyordered: Yup.number()
	.integer('Enter valid Qty. Ordered')
	.required('Qty. Ordered is required')
	.moreThan(0, 'Enter valid Qty. Ordered'),
	qtyreceived: Yup.number()
	.integer('Enter valid Qty. Received')
	.required('Qty. Received is required')
	.moreThan(0, 'Enter valid Qty. Received'),
	qtybilled: Yup.number()
	.integer('Enter valid Qty. Billed')
	.required('Qty. Billed is required')
	.moreThan(0, 'Enter valid Qty. Billed'),
	packagesprice: Yup.number()
	.required('Package Price required')
	.moreThan(0, 'Enter valid Package Price'),
	// totalprice: Yup.string().required('Required'),
	// comment: Yup.string().required('Required')
});

var wholeaccountid = '';
let wholeAccountids = [];
let whosalerids = [];
let orderinvoice = '';
let accumulationprice = [];
const AddOrderModal = ({ isOpen, toggle, tenantID, ceid, phid,tpid, refetch }) => {
	const API = useAxios();
	const [state, updateState] = useState({
		rows: []
	});
	const [wholesalers, setwholesalers] = useState([]);
	const [orderDate, setOrderDate] = useState(null);
	const [receivedDate, setReceivedDate] = useState(null);
	const [invoiceDate, setInvoiceDate] = useState(null);
	const [poid, setPoid] = useState(null);
	const [selectedNdc, setSelectedNdc] = useState('');
	const [qtOrdervalue, setQtOrdervalue] = useState('');
	const [err, setError] = useState(false);
	const [wholeAccIdError, setWholeAccIdError] = useState(false);
	const [invoiceError, setInvoiceError] = useState(false);
	const [loading, setLoading] = useState(false);
	const [wholeid, setwholeid] = useState('');

	const [isflag, setIsflag] = useState(false);
	useEffect(() => {
		fetchWholesalers();
	}, []);
	const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

	const handleSubmit = (val, actions) => {

		const { resetForm, setSubmitting } = actions;
		val.id = 'id' + Math.random().toString(16).slice(2);
		//val.qtybilled = parseInt(val.qtybilled);
		val.packagesprice = (val.packagesprice) ? val.packagesprice : 0;
		val.qtybilled = (val.qtybilled) ? val.qtybilled : 0;
		val.qtyordered = (val.qtyordered) ? val.qtyordered : 0;
		val.qtyreceived = (val.qtyreceived) ? val.qtyreceived : 0;
		val.totalprice = val.packagesprice * val.qtybilled;
		setState({
			rows: [...state.rows, { ...val }]
		});
		resetForm();
		setIsflag(true);
		setSubmitting(false);
		setSelectedNdc('');
	};
	const validations = () => {

		if (wholeid == '' || wholeid === undefined || wholeaccountid === '' || wholeaccountid === undefined || orderDate == null || invoiceDate == null || orderinvoice === '' || orderinvoice === undefined) {
			setError(true);
			setWholeAccIdError(true);
			setInvoiceError(true);
			return true;
		}
		return false;
	}
	const { rows } = state;

	const handleorder = async () => {
         
		if (validations()) {
			return true;
		}

		setLoading(true);
		let payload = {};
		payload.ItemInvoicedDate = moment(invoiceDate).format('MM/DD/YYYY');
		if (receivedDate != null && receivedDate != undefined) payload.ReceivedDate = moment(receivedDate).format('MM/DD/YYYY');
		payload.ItemOrderedDate = moment(orderDate).format('MM/DD/YYYY');
		payload.Invoice = orderinvoice;
		payload.POID = poid;
		payload.WholesalerName = wholeid;
		payload.WholesaleraccountID = wholeaccountid;
		payload.AddPOOrderModelfilter = state.rows;

		let ceId = ceid.map(item => item["value"])[0];
		let phId = phid.map(item => item["value"])[0];
		try {
			const { data } = await API.post(`/${tenantID}/PurchaseOrder/AddPurchaseOrder/${ceId}/${phId}`, payload);
			if (data) {
				if (data.error) {
					toast.error(result.data.message);

				}
				else {
					toast.success('Order added successfully');
					toggle();
					refetch();
					setLoading(false);
				}
			}
		} catch (error) {

			setLoading(false);
		}
	};
	const onHandleDelete = (id) => {
		const updatedRows = rows.filter((item) => item.id !== id);
		setState({
			rows: updatedRows
		});
		if(updatedRows.length==0){

		setIsflag(false);
		}
		else{
			setIsflag(true)
		}
	
	};
	const fetchWholesalers = async () => {
		whosalerids = [];
		try {
			// const payload = {};
			// payload.CoveredEntityIDs = ceid.map(item => item["value"]);
			// payload.pharmacyIds = phid.map(item => item["value"]);
			let ceId = ceid.map(item => item["value"])[0];
			let phId = phid.map(item => item["value"])[0];
			const { data } = await API.get(`GWConfig/wholesaler/wholesalerslist/${ceId}/${phId}`, {
				hasDefaultURL: true,
			});
			if (data) {
				for (var x in data) {
				
					whosalerids.push({ "id": data[x].wholesalerID, "description": data[x].wholeSalerName })
				}
				setwholesalers(whosalerids);
			} else {
				setwholesalers([]);
			}
		} catch (error) { }
	};
	const fetchaccuntids = async(whId)=>{
		try {
			// const payload = {};
			// payload.CoveredEntityIDs = ceid.map(item => item["value"]);
			// payload.PharmacyIDs = phid.map(item => item["value"]);
			let ceId = ceid.map(item => item["value"])[0];
			let phId = phid.map(item => item["value"])[0];
			let wholesalerId = parseInt(whId);
			const { data } = await API.get(`GWConfig/wholesaler/wholesalersaccountlist/${wholesalerId}/${ceId}/${phId}`, {
				hasDefaultURL: true,
			});
			if (data) {
				for (var x in data) {
					//var accountType = data[x].accountTypeID === 13001 ? "(340B)" : "(Non-340B)";
					wholeAccountids.push({ "id": data[x].wholesalerAccountID, "label": data[x].wholesalerAccountCode })
				}
			} else {

			}
		} catch (error) { }
	}
	const handlewholesaler = async (e) => {
		wholeAccountids = [];
		setwholeid( e.target.value);
		fetchaccuntids(e.target.value)
		
	};

	const handlewholesalerAccount = (e) => {
		if (wholeaccountid = e.target.value) {
			setWholeAccIdError(false);
		}
	};
	const handleDateClick = (id) => {
		if (hasDatePopupOpen) {
			hasDatePopupOpen = false;
			return;
		}
		const calendarButton = document.getElementById(id);
		if (calendarButton) {
			calendarButton.click();
			hasDatePopupOpen = true;
		}
	};
	const handleOrderDate = (orderDate) => {
		setOrderDate(orderDate);
		// var ordate = moment(new Date(orderDate)).format(
		// 	'MM/DD/YYYY'
		// );
		// setOrderDate(ordate);
	};

	const handleOrderDateRaw = (e) => {
		var val = e.target.value;
		var dt = moment(val, "MM/DD/YYYY", true);
		var isValid = dt.isValid();
		if (isValid == false && orderDate !== null) {
			setOrderDate(null);
		}

		if (isValid) {
			handleOrderDate(e.target.value);
		}
	}

	const handleReceiveDate = (receivedDate) => {
		setReceivedDate(receivedDate);
		// var recdate = moment(new Date(receivedDate)).format(
		// 	'MM/DD/YYYY'
		// );
		// setReceivedDate(recdate);
	};

	const handleReceiveDateRaw = (e) => {
		var val = e.target.value;
		var dt = moment(val, "MM/DD/YYYY", true);
		var isValid = dt.isValid();
		if (isValid == false && receivedDate !== null) {
			setReceivedDate(null);
		}

		if (isValid) {
			handleReceiveDate(e.target.value);
		}
	}


	const handleInvoiceDate = (invoiceDate) => {
		setInvoiceDate(invoiceDate);
		// var invodate = moment(new Date(invoiceDate)).format(
		// 	'MM/DD/YYYY'
		// );
		// setInvoiceDate(invodate);
	};

	const handleInvoiceDateRaw = (e) => {
		var mxdt = new Date(orderDate)
		var valdt = new Date();
		var val = e.target.value;
		var dt = moment(val, "MM/DD/YYYY", true);
		var isValid = dt.isValid();
		if (isValid == false && invoiceDate !== null) {
			setInvoiceDate(null);
		}

		if (isValid && val <= valdt && val >= mxdt) {
			handleInvoiceDate(e.target.value);
		}
	}


	const handleNdc = (ndc, setFieldValue) => {
		if (ndc !== null) {
			setSelectedNdc(ndc) !== ndc
			setFieldValue('ndc', ndc.id.toString());
			setFieldValue('Desc', ndc.description)
			handleAccumulation(ndc, setFieldValue);
		}
		else {
			setSelectedNdc(null)
			setFieldValue('ndc', null);
		}

	};
	const handlepackagesprice = (e, setFieldValue) => {

		setFieldValue('packagesprice', e.target.value);
		let total = (qtOrdervalue * e.target.value);
		setFieldValue('totalprice', total);
	}
	const handleqtybilled = (e, setFieldValue) => {

		setFieldValue('qtybilled', e.target.value);
		setQtOrdervalue(e.target.value);
	}
	const handleAccumulation = async (ndc, setFieldValue) => {

		try {
			const { data } = await API.get(`/${tenantID}/PurchaseOrder/AccumulationList/${ndc.id}`);

			if (data.length > 0) {
				for (var x in data) {
					accumulationprice.push((data[x].openingUnits + data[x].accumulations + data[x].adjustmentUnits) - (data[x].orderedUnits + data[x].truedUpUnits + data[x].orderedUnits));
					setFieldValue('accumulation', accumulationprice[0].toString())
				}
			} else {
				setFieldValue('accumulation', '0')
			}
		} catch (error) { }
	}
	const handleMouseLeave = () => {
		hasDatePopupOpen = false;
	};

	const handlepharmacy = (e) => {
		var poid = e.target.value;
		setPoid(poid);
		setError('');
	}
	const handleInvoice = (e) => {
		if (orderinvoice = e.target.value) {
			setInvoiceError(false);
		}
		orderinvoice = e.target.value;
	}
	return (
		<div>

			<Formik
				//onSubmit={handleSubmit}
				initialValues={''}
				//validationSchema={validationSchema}
				enableReinitialize={true}
				children={(props) => {
					const { isSubmitting, handleSubmit, setSubmitting } = props;
					return (
						<div>

							<Row>
								<Col md={3}>

									<FormGroup>
										<Label for="wholesaler">Wholesaler</Label>
										<Field
											name='wholesaler'
											type='text'
											className='required'
											value={wholeid}
											show={true}
											onChange={handlewholesaler}
											component={FormikSelectField}
											options={wholesalers}
											defaultoption='--Select--'
											keys={{
												id: 'id',
												label: 'description',
											}}
										/>
										{(err) && (wholeid == '' || wholeid === undefined) && <div className="text-danger f-12">
											Please select a Wholesaler</div>}
									</FormGroup>

								</Col>
								{/* <Col md={1}>
									&nbsp;
								</Col> */}

								<Col md={3} >
									<FormGroup>
										<Label for="wholesaler-account">Wholesaler Account</Label>
										<Input
											className='required'
											id="wholesaler-account"
											name="wholesaler-account"
											placeholder="wholesaler-account"
											type="select"
											onChange={handlewholesalerAccount}
										>
											<option value={''}>--Select--</option>
											{wholeAccountids.map((status) => {
												const { id, label } = status;
												return (
													<option key={id} value={id}>
														{label}
													</option>
												);
											})}
										</Input>
										{(wholeAccIdError) && (wholeaccountid === '' || wholeaccountid === undefined) && <div className="text-danger f-12">
											Please select a Wholesaler Account</div>}
									</FormGroup>
								</Col>
								{/* <Col md={1}>
									&nbsp;
								</Col> */}
								<Col md={3} sm={3} xs={6}>
									<FormGroup>
										<Label for="po">Source PO#</Label>
										<Input type='text' name='pharmacy' placeholder='Enter Source PO number' autoComplete='off' onChange={handlepharmacy} />
									</FormGroup>
								</Col>

								<Col md={3} sm={3} xs={6} className='' >
									<div className='required-date'>
										<FormGroup>
											<Label>Order Date</Label>
											<InputGroup onMouseLeave={handleMouseLeave}>
												{/* <Field
												type='text'
												id='orderDate'
												name='orderDate'
												autoComplete='off'
												placeholder='Select a date'
												value={orderDate}
												component={FormikDatePicker}
												onChange={handleOrderDate}
												setcss='required'
											/> */}
												<DatePicker
													id='orderDate'
													name='orderDate'
													selected={orderDate}
													onChange={(e) => { handleOrderDate(e) }}
													onChangeRaw={handleOrderDateRaw}
													dateFormat="MM/dd/yyyy"
													placeholderText='Select a date'
													autoComplete='off'
													customInput={
														<ReactInputMask mask="99/99/9999"
															value={orderDate}
														// maskChar=''
														/>
													}
												/>
												<InputGroupText
													onClick={() => handleDateClick('orderDate')}
												>
													<img src={Calendar} alt='' />
												</InputGroupText>
											</InputGroup>
											{err && (orderDate === null) && <div className="text-danger f-12">
												Please select a Order Date</div>}
										</FormGroup>
									</div>

								</Col>
								{/* <Col md={1}>
									&nbsp;
								</Col> */}
								<Col md={3} className='purchase-date'>
									<FormGroup>
										<Label>Received Date</Label>
										<InputGroup onMouseLeave={handleMouseLeave}>
											{/* <Field
												type='text'
												id='receivedDate'
												name='receivedDate'
												autoComplete='off'
												placeholder='Select a date'
												value={receivedDate}
												component={FormikDatePicker}
												onChange={handleReceiveDate}
											/> */}
											<DatePicker
												id='receivedDate'
												name='receivedDate'
												selected={receivedDate}
												onChange={(e) => { handleReceiveDate(e) }}
												onChangeRaw={handleReceiveDateRaw}
												dateFormat="MM/dd/yyyy"

												placeholderText='Select a date'
												autoComplete='off'
												customInput={
													<ReactInputMask mask="99/99/9999"
														value={receivedDate}
													// maskChar=''
													/>
												}
											/>
											<InputGroupText
												onClick={() => handleDateClick('receivedDate')}
											>
												<img src={Calendar} alt='' />
											</InputGroupText>

										</InputGroup>
									</FormGroup>
								</Col>
								{/* <Col md={1}>
									&nbsp;
								</Col> */}
								<Col md={3} sm={1} xs={4} className='required-date'>
									<FormGroup>
										<Label>Invoice Date</Label>
										<InputGroup onMouseLeave={handleMouseLeave}>
											{/* <Field
												type='text'
												id='invoiceDate'
												name='invoiceDate'
												autoComplete='off'
												placeholder='Select a date'
												value={invoiceDate}
												maxDate={new Date()}
												component={FormikDatePicker}
												onChange={handleInvoiceDate}
												setcss='required'
											/> */}
											<DatePicker
												id='invoiceDate'
												name='invoiceDate'
												selected={invoiceDate}
												onChange={(e) => { handleInvoiceDate(e) }}
												onChangeRaw={handleInvoiceDateRaw}
												dateFormat="MM/dd/yyyy"
												placeholderText='Select a date'
												autoComplete='off'
												minDate={new Date(orderDate)}
												maxDate={new Date()}
												customInput={
													<ReactInputMask mask="99/99/9999"
														value={invoiceDate}
													// maskChar=''
													/>
												}
											/>
											<InputGroupText
												onClick={() => handleDateClick('invoiceDate')}
											>
												<img src={Calendar} alt='' />
											</InputGroupText>

										</InputGroup>
										{err && (invoiceDate === null) && <div className="text-danger f-12">
											Invoice Date is required field</div>}
									</FormGroup>
								</Col>

								<Col md={3} sm={2} xs={4}>
									<FormGroup>
										<Label for="invoice">Invoice Number</Label>
										<Input id="order" className='required' name="order" placeholder="Enter Invoice number" type="number" onChange={handleInvoice} autoComplete='off' />
										{invoiceError && (orderinvoice === '' || orderinvoice === undefined) && <div className="text-danger f-12">
											Invoice Number is required field</div>}
									</FormGroup>
								</Col>
							</Row>

						</div>
					);
				}}
			/>
			{loading && <Loader />}
			<hr />

			<div className="table-card ndc_info">
				<div className='table-responsive'>
					<table className="table theme-table">
						<thead style={{ borderRadius: "5px" }}>
							<tr>
								<th width="350">NDC/Drug Name</th>
								{/* <th>Current Accumulation</th> */}
								<th width="120">Qty. Ordered</th>
								<th width="120">Qty. Received</th>
								<th width="120">Qty. Billed</th>
								<th width="140">Package Price ($)</th>
								<th width="120">Total Price ($)</th>
								<th width="120">Comments</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<Formik
								onSubmit={handleSubmit}
								initialValues={initialValues}
								validationSchema={validationSchema}
								enableReinitialize={true}
								children={(props) => {
									const { isSubmitting, handleSubmit, setSubmitting, setFieldValue, errors, values } = props;
									return (
										<tr style={{ backgroundColor: "#f2f7fa" }}>
											<td style={{ paddingLeft: "1px" }}>
												<NDCList
													name='ndc'
													onSelect={(value) => handleNdc(value, setFieldValue)}
													selectedNDC={selectedNdc}
												/>
												{errors.validationSchema && <div className="text-danger f-12">
													{errors.ndc}</div>}
											</td>	
											{/* <td>

											<Field
												id="accumulation"
												name="accumulation"
												type="text"
												autoComplete="off"
												component={FormikInputField}
												disabled={true}
												style={{ height: 42, width: 100, borderRadius: 5 }}

											/>
										</td> */}
											<td width={75}>
												<Field
													id="qtyordered"
													name="qtyordered"
													type="number"
													autoComplete="off"
													component={FormikInputField}
													className="required"
													style={{ borderRadius: 8 }}

												/>
											</td>
											<td width={75}>
												<Field
													id="qtyreceived"
													name="qtyreceived"
													type="number"
													autoComplete="off"
													component={FormikInputField}
													className="required"
													style={{ borderRadius: 8 }}
												/>
											</td>
											<td width={75}>

												<Field
													id="qtybilled"
													name="qtybilled"
													type="number"
													autoComplete="off"
													component={FormikInputField}
													//onChange={(value) => handleqtybilled(value, setFieldValue)}
													className="required"
													style={{ borderRadius: 8 }}
												/>


											</td>
											<td width={75}>

												<Field
													id="packagesprice"
													name="packagesprice"
													type="number"
													autoComplete="off"
													className="required"
													component={FormikInputField}
													//onChange={(value) => handlepackagesprice(value, setFieldValue)}
													style={{ borderRadius: 8 }}
												/>


											</td>
											<td width={75}>
												{values.packagesprice && values.qtybilled ? <div >{(values.packagesprice * values.qtybilled).toFixed(2)} </div> : null}
												{/* <Field
												id="totalprice"
												name="totalprice"
												type="text"
												autoComplete="off"
												component={FormikInputField}
												style={{ height: 42, width: 71, borderRadius: 5 }}
												disabled={true}

											/> */}
											</td>
											<td>
												<Field
													id="comment"
													name="comment"
													type="textarea"
													autoComplete="off"
													rows={1}
													component={FormikInputField}
													style={{}}
												/>
											</td>
											<td>
												<Button
													disabled={isSubmitting}
													onClick={handleSubmit}
													type="submit"
													color="link"
												>
													<FontAwesomeIcon
														icon={faPlusCircle}
														className="text-primary f-22"
													/>
												</Button>
											</td>
										</tr>
									);
								}}
							/>
							{rows.map((item) => {
								return (
									<Formik
										key={item.id}
										initialValues={{
											ndc: item.Desc,
											//accumulation: item.accumulation,
											qtyordered: item.qtyordered,
											qtyreceived: item.qtyreceived,
											qtybilled: item.qtybilled,
											packagesprice: item.packagesprice,
											totalprice: item.qtybilled * item.packagesprice,
											comment: item.comment
										}}
										validationSchema={validationSchema}
										enableReinitialize={true}
										children={(props) => {
											const { values } = props;
											return (
												<tr key={item.id} style={{ backgroundColor: "#f2f7fa" }}>
													<td>
														{item.Desc}
													</td>
													{/* <td>
													{item.accumulation}
												</td> */}
													<td>
														<Field
															id="qtyordered"
															name="qtyordered"
															type="text"
															autoComplete="off"
															component={FormikInputField}
															disabled={true}
															style={{ borderRadius: 8 }}
														/>
													</td>
													<td>
														<Field
															id="qtyreceived"
															name="qtyreceived"
															type="text"
															autoComplete="off"
															component={FormikInputField}
															disabled={true}
															style={{ borderRadius: 8 }}
														/>
													</td>
													<td>
														<Field
															id="qtybilled"
															name="qtybilled"
															type="text"
															autoComplete="off"
															component={FormikInputField}
															disabled={true}
															style={{ borderRadius: 8 }}
														/>
													</td>
													<td>
														<Field
															id="packagesprice"
															name="packagesprice"
															type="text"
															autoComplete="off"
															component={FormikInputField}
															disabled={true}
															style={{ borderRadius: 8 }}
														/>
													</td>
													<td>
														{values.packagesprice && values.qtybilled ? <div>{(values.packagesprice * values.qtybilled).toFixed(2)}</div> : null}
														{/* <Field
														id="totalprice"
														name="totalprice"
														type="text"
														autoComplete="off"
														component={FormikInputField}
														style={{ height: 42, width: 71, borderRadius: 5 }}
													/> */}
													</td>
													<td style={{ width: "160px" }}>
														<Field
															id="comment"
															name="comment"
															type="textarea"
															autoComplete="off"
															rows={1}
															component={FormikInputField}
															disabled={true}
														/>
													</td>
													<td>
														<Button
															className='cursor-pointer text-decoration-underline'
															color="link"
															onClick={() => onHandleDelete(item.id)}



														>
															<FontAwesomeIcon
																icon={faTimesCircle}
																className="text-muted  f-22"
															/>
														</Button>
													</td>
												</tr>
											);
										}}
									/>
								);
							})}
						</tbody>
					</table>
				</div>

			</div>
			{/* <Row className="align-items-center justify-content-between mb-2">
				<Col>
					<p className="text-muted f-12 m-0">
						*Qty Ordered, Qty Received and Qty Billed cannot be zero, negative and decimal values.
					</p>
				</Col>
				<Col xs="auto">
					<Button size="sm" color="info" className="ms-auto" disabled>
						IMPORT DATA
					</Button>
				</Col>
			</Row> */}
			<div style={{display: 'flex',justifyContent:"space-between" }} className='mt-3' >
				<div style={{display:"flex",alignItems:"center"}}>			<p style={{marginBottom:0}}><strong>Note :</strong> Qty Ordered, Qty Received and Qty Billed cannot be zero, negative or decimal values.</p>
				</div>
				<div>
				<Button color="primary" className='search' onClick={handleorder} loading={loading} disabled={isflag == false} >
					<span className="right_5"> 
						<img src={save} alt="" />
					</span> Complete Order
				</Button>
				<Button color="primary" className='reset' onClick={toggle}>
					<span className='right_5'><img src={cancel} alt="" /></span> Cancel
				</Button>{' '}
				</div>
			</div>

		</div>
	);
};

export default AddOrderModal;
